import { Injectable } from '@angular/core';
import { filter, startWith, tap } from 'rxjs/operators';

import * as LogRocket from 'logrocket';
import { AuthStoreService } from '../../shared/services/auth/auth-store.service';
import { SensitiveDataSanitizer } from '../utils/sensitive-data-sanitizer';
import { AppConfig } from './app-config.service';
import { VersionCheckService } from './version-check.service';
import { AuthState } from '../../shared/models/auth/auth-state.model';

@Injectable({
  providedIn: 'root',
})
export class LogRocketService {
  private sanitizer = new SensitiveDataSanitizer();

  constructor(
    private auth: AuthStoreService,
    private appConfig: AppConfig,
    private versionCheck: VersionCheckService,
  ) {}

  public init(): void {
    if (!this.appConfig.config.logRocket.enabled) {
      return;
    }

    LogRocket.init(this.appConfig.config.logRocket.appId, {
      console: {
        shouldAggregateConsoleErrors: true,
      },
      dom: {
        isEnabled: !this.appConfig.config.logRocket.disableDOMRecording,
      },
      network: {
        isEnabled: true,
        requestSanitizer: this.sanitizer.sanitizeRequest.bind(this.sanitizer),
        responseSanitizer: this.sanitizer.sanitizeResponse.bind(this.sanitizer),
      },
      browser: {
        urlSanitizer: this.sanitizer.sanitizeUrl.bind(this.sanitizer),
      },
      release: this.versionCheck.version,
      rootHostname: this.appConfig.config.logRocket.rootHostname,
    });

    this.initIdentification();
  }

  public logError(response): void {
    LogRocket.error(response);
  }

  private initIdentification(): void {
    this.auth.state$
      .pipe(
        startWith(this.auth.state),
        filter((state) => state === AuthState.AUTHENTICATED),
        tap(() => this.identifyUser()),
      )
      .subscribe();
  }

  public identifyUser(): void {
    LogRocket.identify(this.auth.userInfo.customer_id, {
      email: this.auth.userInfo.email,
      name: this.auth.userInfo.name,
    });
  }
}
